import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StandardHeadline from "../../../elements/text/standardHeadline.text";
import StandardText from "../../../elements/text/standardText.text";
import { passStatus } from "./Welcom.page";

export default function Login({
  userPassedStatus,
  name,
  password,
  setName,
  setPassword,
}) {
  const intl = useIntl();

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
  };
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
  };

  return (
    <div className="w-100">
      <div className="mb-5">
        <StandardHeadline className={"mb-2 mt-3"} type={"h2"}>
          <FormattedMessage id="intro.login" />
        </StandardHeadline>
        <StandardText>
          {intl.formatMessage({ id: "intro.login.welcomeMessage" })}
        </StandardText>
      </div>
      <div className="mb-3">
        <StandardHeadline className="mb-1">
          {intl.formatMessage({ id: "intro.login.name" })}
        </StandardHeadline>
        <input
          value={name}
          onChange={handleNameChange}
          type="text"
          className="p-2 w-100"
          style={{ border: "1px solid lightgray", borderRadius: "5px" }}
        />
      </div>
      <div>
        <StandardHeadline>
          {intl.formatMessage({ id: "intro.login.password" })}
        </StandardHeadline>
        <input
          value={password}
          onChange={handlePasswordChange}
          type="password"
          className="p-2 w-100"
          style={{ border: "1px solid lightgray", borderRadius: "5px" }}
        />
      </div>
      <LoginStatus status={userPassedStatus} />
    </div>
  );
}

function LoginStatus({ status }) {
  const [iconname, setIconname] = useState(null);
  const [className, setClassName] = useState(null);

  useEffect(() => {
    switch (status) {
      case passStatus.correct:
        setIconname("check");
        setClassName("");
        break;
      case passStatus.nothing:
        setIconname(null);
        setClassName("");
        break;
      case passStatus.waiting:
        setIconname("spinner-third");
        setClassName("fa-spin");
        break;
      case passStatus.wrong:
        setIconname("times");
        setClassName("");
        break;
      default:
    }
  }, [status]);

  if (iconname) {
    return (
      <div className="p-3 d-flex justify-content-center">
        <FontAwesomeIcon
          icon={["fal", iconname]}
          className={className}
          style={{ width: "3rem", height: "3rem" }}
        />
      </div>
    );
  } else return null;
}
